<template>
  <div>
        <h1>{{tituloh1}}</h1>
        <!-- <div class="alert alert-info">
            ¡Atención! éste sistema de firma solo deberá usarse cuando el cliente (propietario del documento de contrato) acepta que se lleva a cabo la firma a través de nuestra plataforma de firma electrónica (Signaturit)
        </div> -->

        <div class="my-3">
            <b-card v-if="!datosexpediente" bg-variant="light">
                <b-form-group
                    label-cols-lg="3"
                    label="Código de expediente"
                    label-for="expediente"
                    description="Introduce el código del expediente a buscar"
                    :state="state"
                    >
                    <b-input-group>
                        <b-form-input id="expediente" v-model="expediente" :state="state" trim></b-form-input>
                        <b-input-group-append>
                            <b-button class="bgcolor-manusa" @click="buscar" :disabled="!state">Buscar</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-card>
            <div v-else>
                <h2>Expediente: {{ datosexpediente.codigo }} - {{ datosexpediente.descripcion }}</h2>
                <h5>Firmantes del contrato</h5>
                <ul>
                    <li v-for="f in datosexpediente.firmantes" :key="f.email">{{ f.nombre }} &lt;{{ f.email }}&gt; - en representación de {{ f.empresa }}</li>
                </ul>
                <h5>Hoja de Validación</h5>
                <b-card bg-variant="light">
                    <b-row>
                        <b-col cols="8">
                            <b-row class="border-bottom my-1">
                                <b-col cols="3" class="text-right font-weight-bold">Fecha</b-col><b-col>{{datosexpediente.hojavalidacion.fecha}}</b-col>
                                <b-col cols="3" class="text-right font-weight-bold">Urgente</b-col><b-col>{{datosexpediente.hojavalidacion.urgente}}</b-col>
                            </b-row>
                            <b-row class="border-bottom my-1">
                                <b-col cols="3" class="text-right font-weight-bold">Delegacion</b-col><b-col>{{datosexpediente.hojavalidacion.delegacion}}</b-col>
                                <b-col cols="3" class="text-right font-weight-bold">Comercial</b-col><b-col>{{datosexpediente.hojavalidacion.comercial}}</b-col>
                            </b-row>
                            <b-row class="border-bottom my-1">
                                <b-col cols="3" class="text-right font-weight-bold">Gestionado por</b-col><b-col>{{datosexpediente.hojavalidacion.gestionadopor}}</b-col>
                            </b-row>
                            <b-row class="border-bottom my-1">
                                <b-col cols="3" class="text-right font-weight-bold">Cliente</b-col><b-col>{{datosexpediente.hojavalidacion.cliente}}</b-col>
                            </b-row>
                            <b-row class="border-bottom my-1">
                                <b-col cols="3" class="text-right font-weight-bold">Obra/Servicio</b-col><b-col>{{datosexpediente.hojavalidacion.obraservicio}}</b-col>
                            </b-row>
                            <b-row class="border-bottom my-1">
                                <b-col cols="3" class="text-right font-weight-bold">Nº puertas</b-col><b-col>{{datosexpediente.hojavalidacion.numpuertas}}</b-col>
                            </b-row>
                            <b-row class="border-bottom my-1">
                                <b-col cols="3" class="text-right font-weight-bold">Importe</b-col><b-col>{{datosexpediente.hojavalidacion.importe}} €</b-col>
                                <b-col cols="3" class="text-right font-weight-bold">Forma de pago</b-col><b-col>{{datosexpediente.hojavalidacion.formadepago}}</b-col>
                            </b-row>
                            <b-row class="border-bottom my-1">
                                <b-col cols="3" class="text-right font-weight-bold">Asegurado</b-col><b-col>{{datosexpediente.hojavalidacion.asegurado}}</b-col>
                                <b-col cols="3" class="text-right font-weight-bold">Penalización</b-col><b-col>{{datosexpediente.hojavalidacion.penalizacion}}</b-col>
                            </b-row>
                            <b-row class="border-bottom my-1">
                                <b-col cols="3" class="text-right font-weight-bold">Comentarios</b-col><b-col>{{datosexpediente.hojavalidacion.comentarios}}</b-col>
                            </b-row>
                        </b-col>
                        <b-col class="text-center">
                            <div v-if="datosexpediente.validado">
                                <h5>Validación realizada por:</h5>
                                <ul style="list-style:none">
                                    <li v-for="f in datosexpediente.validadopor" :key="f.email">{{ f.nombre }} - {{ f.fecha }}</li>
                                </ul>
                                <div class="mt-5 alert alert-info ml-5">
                                    Esta información se enviará a {{datosexpediente.firmantes[0].nombre}} a través de un email personal, en el momento en que se formalice el envío del documento.
                                </div>
                            </div>
                            <div v-else>
                                <h5>No Realizada todavía</h5>
                            </div>
                        </b-col>
                    </b-row>
                </b-card>
                <div v-if="motivonocontinuar!==''" class="my-2 alert alert-warning">¡ATENCION! {{motivonocontinuar}}</div>
            </div>
        </div>

        <div class="w-100 d-flex justify-content-between mb-4">            
            <b-button @click="resetbusqueda" class="bgcolor-manusa">
                Buscar otro expediente
            </b-button>
            <b-button :disabled="motivonocontinuar!==''" @click="siguientepaso" class="bgcolor-manusa">
                Siguiente
                <b-icon-arrow-right-circle-fill></b-icon-arrow-right-circle-fill>
            </b-button>
        </div>
  </div>
</template>

<script>
    export default {
        props: {
            tituloh1: {
                type: String,
                default: "Indica el expediente del contrato que se va a enviar a firmar por via electrónica"
            },
        },
        data() {
            return {
                expediente: "",
                motivonocontinuar: "",
                expedientevalidoefirma: false,
                datosexpediente: null,
            }
        },
        mounted () {
            /*
            this.options=[]
            var _t = this
            this.axios.get("adsi/users/s/solo-manusa")
            .then(function (response) {
                console.log("SeleccionPersonaManusa", response.data);
                response.data.forEach(u => {
                    _t.options.push(u["Nombre Completo"])
                })             
            })
            .catch(function (error) {
                console.log(error);
            })
            .then(function () {
                // always executed
            })
            */
        },
        methods: {
            siguientepaso() {
                this.$emit('expediente-seleccionado', this.datosexpediente)
            },
            resetbusqueda() {
                this.datosexpediente=null
                this.expediente=""
            },
            buscar() {
                this.datosexpediente = {
                    "codigo": this.expediente,
                    "descripcion": "PY000001-CL0000001-RUE-13-PERCEBE-Cuartel-General",
                    "firmantes": [
                        { "nombre": "Josep Medina", "email": "josep.medina@manusa.com", "empresa":"MANUSA", "linea1": "Fdo. D. Josep Medina", "linea2": "Director General Grupos Manusa", "linea3": "En representación de Manusa Door Systems, S.L." },
                        { "nombre": "Filemón Pi", "email": "filemon.pi@manusa.com", "empresa":"TIA S.L.", "linea1": "Fdo. D. Filemón Pi", "linea2": "Director General TIA", "linea3": "" },
                    ],
                    "validado": true,
                    "validadopor": [
                        { "nombre": "Cesar Alvarez", "email": "cesar.alvarez", "cargo": "Director Comercial", "fecha": "2020-09-10" },
                        { "nombre": "Agustín Carrasco", "email": "agustin.carrasco", "cargo": "Comercial", "fecha": "2020-09-10" }
                    ],
                    "hojavalidacion": {
                        "fecha": "2020-09-01",
                        "urgente": true,
                        "delegacion": "Centro",
                        "departamento": "Venta",
                        "comercial": "Agustín Carrasco",
                        "gestionadopor": "Angel Ortega",
                        "cliente": "TIA, S.L.",
                        "obraservicio": "RUE 13, PERCEBE - Cuartel General",
                        "numpuertas": "1",
                        "importe": 3500,
                        "formadepago": "Transferencia bancaria",
                        "asegurado": "-",
                        "penalización": "-",
                        "comentarios": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla est purus, ultrices in porttitor in, accumsan non quam. Nam consectetur porttitor rhoncus. Curabitur eu est et leo feugiatauctor vel quis lorem. Ut et ligula dolor, sit amet consequat lorem.\nAliquam porta eros sedvelit imperdiet egestas. Maecenas tempus eros ut diam ullamcorper id dictum liberotempor. Donec quis augue quis magna condimentum lobortis. Quisque imperdiet ipsum velmagna viverra rutrum. Cras viverra molestie urna, vitae vestibulum turpis varius id.",
                        "solicitudasesoramiento": true,
                        "respuestaasesoramientorecibida": true,
                        "detallesolicitudasesoramiento": {
                            "preguntasplanteadas": "",
                            "respuesta": ""
                        }
                    },
                    "permiteiniciarfirma": true,
                    "solicitudefirmaenviadaacliente": true,
                    "respuestasolicitudefirmacliente": {           // Puede ser null => no enviada, { "fecharespuesta": <fecha>, "aceptada": <boolean> }
                        "fecharespuesta": "2020-09-22",
                        "aceptada": true
                    },
                    "procesoefirma": {
                        "enviadaaefirmantes": false,
                        "estadoefirma": null                            // Puede ser null => no iniciada, "PENDIENTE", "COMPLETADA" o "CANCELADA"
                    }
                }

                // PARA LA DEMO
                if (this.expediente==="EXP1001001") this.datosexpediente.permiteiniciarfirma = false;
                if (this.expediente==="EXP1001002") this.datosexpediente.solicitudefirmaenviadaacliente = false;
                if (this.expediente==="EXP1001003") this.datosexpediente.respuestasolicitudefirmacliente = null;
                if (this.expediente==="EXP1001004") this.datosexpediente.respuestasolicitudefirmacliente.aceptada = false;
                if (this.expediente==="EXP1001005") { this.datosexpediente.procesoefirma.enviadaaefirmantes = true; this.datosexpediente.procesoefirma.estadoefirma="PENDIENTE"; }
                if (this.expediente==="EXP1001006") { this.datosexpediente.procesoefirma.enviadaaefirmantes = true; this.datosexpediente.procesoefirma.estadoefirma="COMPLETADA"; }

                console.log(this.datosexpediente)

                // obtenida la respuesta, solo se puede gestionar la firma electrónica de un expediente si
                // - permiteiniciarfirma = true
                // - solicitudefirmaenviadaacliente = true y respuestasolicitudefirmacliente.aceptada = true
                // - procesoefirma.enviadaaefirmantes = false o procesoefirma.enviadaaefirmantes = true y procesoefirma.estadoefirma == "CANCELADA"
                this.motivonocontinuar = ""
                if (!this.datosexpediente.permiteiniciarfirma) { 
                    this.motivonocontinuar = "No se permite todavía iniciar su efirma"  
                } else if (!this.datosexpediente.solicitudefirmaenviadaacliente) { 
                    this.motivonocontinuar = "No se ha enviado solicitud de efirma al cliente todavía"  
                } else if (!this.datosexpediente.respuestasolicitudefirmacliente) { 
                    this.motivonocontinuar = "Todavía no se ha recibido respuesta del cliente aprobando el uso de efirma en contrato" 
                } else if (!this.datosexpediente.respuestasolicitudefirmacliente.aceptada) { 
                    this.motivonocontinuar = "El cliente ha rechazado el uso de efirma en el contrato"
                } else if (this.datosexpediente.procesoefirma.enviadaaefirmantes && this.datosexpediente.procesoefirma.estadoefirma=="PENDIENTE") { 
                    this.motivonocontinuar = "El envío de firma electrónica del contrato está en curso"
                } else if (this.datosexpediente.procesoefirma.enviadaaefirmantes && this.datosexpediente.procesoefirma.estadoefirma=="COMPLETADA") { 
                    this.motivonocontinuar = "El contrato asociado a este expediente consta como ya firmado"
                }
            }
        },
        computed: {
            state() {
                return this.expediente.length >= 4 ? true : false
            },
        },
    }
</script>